
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Settings, Clock, Zap, Volume2 } from 'lucide-react';

interface ExtractionSettingsProps {
  settings: {
    minDuration: number;
    padding: number;
    tolerance: number;
  };
  onSettingsChange: (key: string, value: number) => void;
}

export default function ExtractionSettings({ settings, onSettingsChange }: ExtractionSettingsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <Settings className="h-5 w-5 text-purple-600" />
          <span>Extraction Settings</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="min-duration" className="flex items-center space-x-2">
            <Clock className="h-4 w-4" />
            <span>Minimum Duration (seconds)</span>
          </Label>
          <Input
            id="min-duration"
            type="number"
            min="10"
            max="600"
            value={settings.minDuration}
            onChange={(e) => onSettingsChange('minDuration', parseInt(e.target.value) || 120)}
          />
          <p className="text-sm text-gray-500">
            Minimum duration to be considered as music (30-600 seconds)
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="padding" className="flex items-center space-x-2">
            <Zap className="h-4 w-4" />
            <span>Padding (seconds)</span>
          </Label>
          <Input
            id="padding"
            type="number"
            min="0"
            max="600"
            step="1"
            value={settings.padding}
            onChange={(e) => onSettingsChange('padding', parseFloat(e.target.value) || 15)}
          />
          <p className="text-sm text-gray-500">
            Extra time to include before and after detected music (0-60 seconds)
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="tolerance" className="flex items-center space-x-2">
            <Volume2 className="h-4 w-4" />
            <span>Time Tolerance</span>
          </Label>
          <Input
            id="tolerance"
            type="number"
            min="10"
            max="600"
            step="1"
            value={settings.tolerance}
            onChange={(e) => onSettingsChange('tolerance', parseFloat(e.target.value) || 120)}
          />
          <p className="text-sm text-gray-500">
            Duration of speech that can be acceptable within the song (60 - 300 seconds)
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
